module.exports = __webpack_public_path__ + "img/xiangxi-06fe6b.png";